import { PaperPlaneRight } from "@phosphor-icons/react";

export default function MessageInput({ value, onChange, onSend, disabled }) {
  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };
  return (
    <div className="bg-[#0F0F12] border border-white/10 focus-within:border-blue-500 rounded-xl flex items-center px-4 py-2 transition-colors">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKey}
        placeholder="Ask your career coach..."
        data-testid="chat-input"
        className="flex-1 bg-transparent text-white outline-none py-2"
      />
      <button
        onClick={onSend}
        disabled={disabled || !value.trim()}
        data-testid="chat-send"
        className="bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white p-2 rounded-lg transition-colors"
      >
        <PaperPlaneRight size={18} weight="fill" />
      </button>
    </div>
  );
}
